import { WagmiConfig, createClient, configureChains } from 'wagmi'
import { publicProvider } from 'wagmi/providers/public'
import { Buffer } from "buffer";
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { chain } from '@/utils/abi'

// Configure chains & providers with the Alchemy provider.
// Two popular providers are Alchemy (alchemy.com) and Infura (infura.io)
const { chains, provider, webSocketProvider } = configureChains(
    [chain],
    [
      publicProvider()
    ],
  )
  if (!window.Buffer) {
    window.Buffer = Buffer;
  }



// Set up client
const client = createClient({
    autoConnect: true,
    connectors: [
      new MetaMaskConnector({ chains }),
      new CoinbaseWalletConnector({
        chains,
        options: {
          appName: 'wagmi',
        },
      }),
      new WalletConnectConnector({
        chains,
        options: {
          qrcode: true,
        },
      })
    ],
    provider,
    webSocketProvider,
  })
  
  

export default function WalletProvider({ children }) {
  
  return (
    <WagmiConfig client={client}>
        {children}
    </WagmiConfig>
  )
}
